import React, { useState, useEffect } from "react";
import "./GenerateBarcode.css";
import Barcode from "react-barcode";
import Dialog from "@material-ui/core/Dialog";
import { Button } from "react-bootstrap";

let langData = require("../../../Data/language.json");

const GenerateBarcode = ({ username, expandedBarcode, close, language }) => {
  const [barcodeSize, setBarcodeSize] = useState(1);

  const resizeHandler = () => {
    if (window.innerWidth > window.innerHeight) {
      setBarcodeSize(1.75);
    } else {
      setBarcodeSize(1);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", resizeHandler);
    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);

  return (
    <Dialog open={expandedBarcode} fullScreen={true}>
      <div id="barcodeDialog">
        <Button
          id="barcodeDialogBtn"
          onClick={() => {
            close();
          }}
        >
          {langData[language].profile.backBtn}
        </Button>

        <div id="barcodeWrapper">
          <h5 id="barcodeDialogText">
            {langData[language].profile.scannerDescription}:
          </h5>
          <Barcode
            value={username}
            format="CODE128"
            width={barcodeSize}
            height={100}
            displayValue={true}
          />
          {barcodeSize === 1 && (
            <p id="barcodeGeneratorHelperText">
              {langData[language].profile.scannerHelperText}
            </p>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default GenerateBarcode;
